/**
 * @generated SignedSource<<13eaa50a62c1ef9d04ccacd8ed6d5c19>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteZoomAccountMutationInput = {
  clientMutationId?: string | null;
  orgRelayId: string;
  zoomAccountId: string;
};
export type DeleteZoomAccountMutation$variables = {
  input: DeleteZoomAccountMutationInput;
};
export type DeleteZoomAccountMutation$data = {
  readonly deleteZoomAccount: {
    readonly __typename: string;
    readonly deletedZoomAccountId: string;
    readonly clientMutationId: string | null;
  } | null;
};
export type DeleteZoomAccountMutation = {
  variables: DeleteZoomAccountMutation$variables;
  response: DeleteZoomAccountMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteZoomAccountMutationPayload",
    "kind": "LinkedField",
    "name": "deleteZoomAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedZoomAccountId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteZoomAccountMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteZoomAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "20de5a35ac691739e6ea183b515f383d",
    "id": null,
    "metadata": {},
    "name": "DeleteZoomAccountMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteZoomAccountMutation(\n  $input: DeleteZoomAccountMutationInput!\n) {\n  deleteZoomAccount(input: $input) {\n    __typename\n    deletedZoomAccountId\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1ad706f9ec1e6f67e806731b16d5fa9";

export default node;
